// extracted by mini-css-extract-plugin
export default {"component":"IE3oxyjv","container":"di_6UAM1","option":"nAmTp4qr","text":"gTUcxijv","button":"BqHbjW24"};